<template>
  <div class="mod-config">
    <div class="boxuser" style="height: 100%;">
      <p class="toplist">
        <span style="font-size: 20px;">账号信息</span>
      </p>
      <!-- 模板一 -->
      <div class="userMuban">
        <el-table :data="tableData">
          <el-table-column label="新增数量" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="用户名前缀" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.namePrefix"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="所属企业" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.companyId" filterable placeholder="请选择企业" style="width: 100%">
                <el-option v-for="item in companyOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="角色" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.roleIds" multiple placeholder="请选择角色" style="width: 100%">
                <el-option v-for="item in roleOption" :key="item.roleId" :label="item.roleName" :value="item.roleId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mobile"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="邮件" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.email"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableData">
          <el-table-column label="报表推送" align="center">
            <template slot-scope="scope">
              <el-checkbox label="周报推送" v-model="scope.row.isOpenWeek" :true-label="1" :false-label="0"></el-checkbox>
              <el-checkbox label="月报推送" v-model="scope.row.isOpenMonth" :true-label="1" :false-label="0"></el-checkbox>
              <el-checkbox label="年报推送" v-model="scope.row.isOpenYear" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="告警功能" align="center">
            <template slot-scope="scope">
              <el-checkbox label="短信告警" v-model="scope.row.isOpenSms" :true-label="1" :false-label="0"></el-checkbox>
              <el-checkbox label="邮件告警" v-model="scope.row.isOpenEmail" :true-label="1" :false-label="0"></el-checkbox>
              <el-checkbox label="公众号告警" v-model="scope.row.isOpenWechat" :true-label="1"
                :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 地图 -->
      <div style="height: calc(100% - 350px);">

      </div>
    </div>
    <span slot="footer" class="dialog-footeruser">
      <el-button type="primary" @click="saveGet">确定</el-button>
      &nbsp;&nbsp;
      <router-link to="/indexhome/user" replace>
        <el-button type="danger">取消</el-button>
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: 'batchAddition',
  data() {
    return {
      tableData: [{
        number: "",
        namePrefix: "",
        uniqueCodePrefix: "",
        roleIds: [],
        mobile: "",
        email: "",
        isOpenWeek: 0,
        isOpenWeek: 0,
        isOpenMonth: 0,
        isOpenYear: 0,
        isOpenSms: 0,
        isOpenEmail: 0,
        isOpenWechat: 0,
      }],
      companyOption: [],
      roleOption: [],
    }
  },
  created() {
    this.getCompanyOption()
    this.getRoleOption()
  },
  methods: {
    //获取企业option
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl("/company/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.companyOption = data.data.companyOption
        }
      })
    },
    //获取角色
    getRoleOption() {
      this.$http({
        url: this.$http.adornUrl("/role/list"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.roleOption = data.data.rows
        }
      })
    },
    saveGet() {
      console.log()
      this.$http({
        url: this.$http.adornUrl('user/saveBatch'),
        method: 'post',
        data: this.$http.adornData({
          "number": this.tableData[0].number,   //新增数量
          "namePrefix": this.tableData[0].namePrefix, //点位名称
          "companyId": this.tableData[0].companyId, //企业id
          "isOpenWeek": this.tableData[0].isOpenWeek,//是否开启周报
          "isOpenMonth": this.tableData[0].isOpenMonth, //是否开启月报
          "isOpenYear": this.tableData[0].isOpenYear, //是否开启年报
          "isOpenSms": this.tableData[0].isOpenSms,  //是否开启短信播报 0关闭 1开启 默认0
          "isOpenEmail": this.tableData[0].isOpenEmail, //是否开启邮件播报 0关闭 1开启 默认0
          "isOpenWechat": this.tableData[0].isOpenWechat, //是否开启公众号播报 0关闭 1开启 默认0
          "roleIds": this.tableData[0].roleIds,    //角色id
          "mobile": this.tableData[0].mobile,
          "email": this.tableData[0].email

        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.$router.replace({ path: '/indexhome/user'});
        } else {
          this.$message.error(data.msg);
        }
      })
    }
  }
}
</script>

<style>
.boxuser .toplist {
  height: 50px;
  line-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #bbb;
}

.mod-config {
  position: relative;
}

.dialog-footeruser {
  display: flex;
  bottom: 0px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  border-top: 2px solid #bbb;
  height: 60px;
}

.userMuban {
  margin-top: 10px;
  height: 226px;
}

.boxuser .userMuban .el-table td,
.boxuser .userMuban .el-table th.is-leaf {
  border-right: none !important
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/batchAdd/userIndex.vue